import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { provideComponentService } from './provideComponentService'
import { ServiceProviderSymbol } from '@wix/thunderbolt-symbols'

export const site: ContainerModuleLoader = (bind) => {
	bind(ServiceProviderSymbol).to(provideComponentService)
}

export const editor: ContainerModuleLoader = site
